export default __webpack_public_path__ + "static/media/safe_bw.991febe5.jpg";